import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Linkedin, Instagram } from 'lucide-react';
import { NewsletterForm } from '@/components/forms/NewsletterForm';
import logo from '@/assets/logo.png';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const navItems = [
    { key: 'home', path: '' },
    { key: 'services', path: '/services' },
    { key: 'methodology', path: '/methodology' },
    { key: 'about', path: '/about' },
    { key: 'blog', path: '/blog' },
    { key: 'contact', path: '/contact' },
  ];

  return (
    <footer className="bg-muted border-t">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand & Newsletter */}
          <div className="space-y-4">
            <Link to={`/${currentLang}`} className="inline-block">
              <img src={logo} alt="FraimeWorks" className="h-8 w-auto" width="175" height="32" />
            </Link>
            <div className="space-y-2">
              <p className="text-sm font-medium">{t('footer.newsletter.title')}</p>
              <NewsletterForm compact />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              {navItems.map((item) => (
                <li key={item.key}>
                  <Link
                    to={`/${currentLang}${item.path}`}
                    className="text-sm text-muted-foreground hover:text-primary transition-base"
                  >
                    {t(`nav.${item.key}`)}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to={`/${currentLang}/privacy`}
                  className="text-sm text-muted-foreground hover:text-primary transition-base"
                >
                  {t('cookie.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${currentLang}/cookies`}
                  className="text-sm text-muted-foreground hover:text-primary transition-base"
                >
                  {t('cookie.cookiePolicy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="font-semibold mb-4">{t('footer.followUs')}</h3>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-base"
                aria-label={currentLang === 'dk' ? 'Følg os på LinkedIn' : 'Follow us on LinkedIn'}
              >
                <Linkedin className="h-6 w-6" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-base"
                aria-label={currentLang === 'dk' ? 'Følg os på Instagram' : 'Follow us on Instagram'}
              >
                <Instagram className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border">
          <p className="text-center text-sm text-muted-foreground">
            © {new Date().getFullYear()} FraimeWorks. {t('footer.rights')}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
